<template>
  <div class="wrapper">
   <div class="card-container">
       <prismic-rich-text :field="fields.contact" />
   </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
      fields: {
        contact: null,
      }
    }
  },
  methods: {
    getContent (uid) {
      this.$prismic.client.getSingle('contact')
          .then((document) => {
            this.fields.contact = document.data.texte_contact;
          })
      }
  },
  created () {
    this.getContent();
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent()
    next()
  }
}
</script>

<style>
.wrapper {
  max-width: 820px;
  margin-left: auto;
  margin-right: auto;
  padding: 40px 10px;
  color: #655F49;
}

.card-container {
    max-width: 90%;
    min-width: 20%;
    padding: 1em 3em;
}
</style>